export default [
    {
        url: 'smile.png',
        code: '[smile]',
        isShow: true,
    },
    {
        url: 'lechery.png',
        code: '[lechery]',
        isShow: true,
    },
    {
        url: 'watermelon.png',
        code: '[watermelon]',
        isShow: true,
    },
    {
        url: 'cool.png',
        code: '[cool]',
        isShow: true,
    },
    {
        url: 'struggle.png',
        code: '[struggle]',
        isShow: true,
    },
    {
        url: 'frown.png',
        code: '[frown]',
        isShow: true,
    },
    {
        url: 'shutup.png',
        code: '[shutup]',
        isShow: true,
    },
    {
        url: 'doubt.png',
        code: '[doubt]',
        isShow: true,
    },
    {
        url: 'cheer.png',
        code: '[cheer]',
        isShow: true,
    },
    {
        url: 'split.png',
        code: '[split]',
        isShow: true,
    },
    {
        url: 'awkward.png',
        code: '[awkward]',
        isShow: true,
    },
    {
        url: 'facepalmcry.png',
        code: '[facepalmcry]',
        isShow: true,
    },
    {
        url: 'angry.png',
        code: '[angry]',
        isShow: true,
    },
    {
        url: 'vomit.png',
        code: '[vomit]',
        isShow: true,
    },
    {
        // eslint-disable-next-line quotes
        url: "don't bicker.png",
        // eslint-disable-next-line quotes
        code: "[don't bicker]",
        isShow: true,
    },
    {
        url: 'cry.png',
        code: '[cry]',
        isShow: true,
    },
    {
        url: 'titter.png',
        code: '[titter]',
        isShow: true,
    },
    {
        url: 'slap.png',
        code: '[slap]',
        isShow: true,
    },
    {
        url: 'let go.png',
        code: '[let go]',
        isShow: true,
    },
    {
        url: 'kneel.png',
        code: '[kneel]',
        isShow: true,
    },
    {
        url: 'laughcry.png',
        code: '[laughcry]',
        isShow: true,
    },
    {
        url: 'teethlaugh.png',
        code: '[teethlaugh]',
        isShow: true,
    },
    {
        url: 'comic.png',
        code: '[comic]',
        isShow: true,
    },
    {
        url: 'crazy.png',
        code: '[crazy]',
        isShow: true,
    },
    {
        url: 'sleepy.png',
        code: '[sleepy]',
        isShow: true,
    },
    {
        url: 'shy.png',
        code: '[shy]',
        isShow: true,
    },
    {
        url: 'bigcry.png',
        code: '[bigcry]',
        isShow: true,
    },
    {
        url: 'pathetic.png',
        code: '[pathetic]',
        isShow: true,
    },
    {
        url: 'like.png',
        code: '[like]',
        isShow: true,
    },
    {
        url: 'drink tea.png',
        code: '[drink tea]',
        isShow: true,
    },
    {
        url: 'dizzy.png',
        code: '[dizzy]',
        isShow: true,
    },
    {
        url: 'astonished.png',
        code: '[astonished]',
        isShow: true,
    },
    {
        url: 'dig nose.png',
        code: '[dig nose]',
        isShow: true,
    },
    {
        url: 'reverse smile.png',
        code: '[reverse smile]',
        isShow: true,
    },
    {
        url: 'fallill.png',
        code: '[fallill]',
        isShow: true,
    },
    {
        url: 'evil.png',
        code: '[evil]',
        isShow: true,
    },
    {
        url: 'dog.png',
        code: '[dog]',
        isShow: true,
    },
    {
        url: 'heart.png',
        code: '[heart]',
        isShow: true,
    },
    {
        url: 'candle.png',
        code: '[candle]',
        isShow: true,
    },
    {
        url: 'blessing.png',
        code: '[blessing]',
        isShow: true,
    },
    {
        url: 'ok.png',
        code: '[ok]',
        isShow: true,
    },
    {
        url: 'arrogant.png',
        code: '[arrogant]',
        isShow: true,
    },
    {
        url: 'snap.png',
        code: '[snap]',
        isShow: true,
    },
    {
        url: 'praise.png',
        code: '[praise]',
        isShow: true,
    },
    {
        url: 'boo.png',
        code: '[boo]',
        isShow: true,
    },
    {
        url: 'applause.png',
        code: '[applause]',
        isShow: true,
    },
    {
        url: 'handshake.png',
        code: '[handshake]',
        isShow: true,
    },
    {
        url: 'kneel cry.png',
        code: '[kneel cry]',
        isShow: true,
    },
    {
        url: 'embrace.png',
        code: '[embrace]',
        isShow: true,
    },
    {
        url: 'stop talking.png',
        code: '[stop talking]',
        isShow: true,
    },
    {
        url: 'hehe.png',
        code: '[hehe]',
        isShow: true,
    },
    {
        url: 'majestic.png',
        code: '[majestic]',
        isShow: true,
    },
    {
        url: 'hard.png',
        code: '[hard]',
        isShow: true,
    },
    {
        url: 'dung.png',
        code: '[dung]',
        isShow: true,
    },
    {
        url: 'amaze.png',
        code: '[amaze]',
        isShow: false,
    },
    {
        url: 'angel.png',
        code: '[angel]',
        isShow: false,
    },
    {
        url: 'bye.png',
        code: '[bye]',
        isShow: false,
    },
    {
        url: 'cute.png',
        code: '[cute]',
        isShow: false,
    },
    {
        url: 'daze.png',
        code: '[daze]',
        isShow: false,
    },
    {
        url: 'follow.png',
        code: '[follow]',
        isShow: false,
    },
    {
        url: 'kiss.png',
        code: '[kiss]',
        isShow: false,
    },
    {
        url: 'rose.png',
        code: '[rose]',
        isShow: false,
    },
    {
        url: 'simper.png',
        code: '[simper]',
        isShow: false,
    },
    {
        url: 'sleep.png',
        code: '[sleep]',
        isShow: false,
    },
    {
        url: 'sweat.png',
        code: '[sweat]',
        isShow: false,
    },
    {
        url: 'wane.png',
        code: '[wane]',
        isShow: false,
    },
];
